import React from "react";

export const Navigation = (props) => {
  const closeMobileMenu = () => {
    const menu = document.getElementById("bs-example-navbar-collapse-1");
    const toggle = document.querySelector("#menu .navbar-toggle");

    if (!menu || !menu.classList.contains("in")) return;

    menu.classList.remove("in");
    menu.setAttribute("aria-expanded", "false");
    toggle?.classList.add("collapsed");
    toggle?.setAttribute("aria-expanded", "false");
  };

  const handleHome = (event, section = "page-top") => {
    if (!props.onHome) return;
    event.preventDefault();
    closeMobileMenu();
    props.onHome(section);
  };

  const handleDetail = (event, slug) => {
    if (!props.onOpenPage) return;
    event.preventDefault();
    closeMobileMenu();
    props.onOpenPage(slug);
  };

  const handleCloud = (event) => {
    if (!props.onOpenCloud) return;
    event.preventDefault();
    closeMobileMenu();
    props.onOpenCloud();
  };

  return (
    <nav
      id="menu"
      className={`navbar navbar-default navbar-fixed-top${
        props.detailMode ? " company-detail-nav" : ""
      }`}
    >
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a
            className="navbar-brand page-scroll"
            href={props.detailMode ? "#company-home" : "#page-top"}
            onClick={(event) => handleHome(event)}
          >
            <img
              src="img/logo/logo-trim.png"
              alt="GOLDLY AI"
              className="navbar-logo"
            />
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {props.detailMode ? (
              <>
                <li>
                  <a
                    href="#company-home"
                    onClick={(event) => handleHome(event)}
                  >
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#company-agent-platform"
                    onClick={(event) =>
                      handleDetail(event, "agent-platform")
                    }
                  >
                    Agents
                  </a>
                </li>
                <li>
                  <a
                    href="#company-global-network"
                    onClick={(event) =>
                      handleDetail(event, "global-presence")
                    }
                  >
                    Global Network
                  </a>
                </li>
                <li>
                  <a
                    href="#company-expertise"
                    onClick={(event) =>
                      handleDetail(event, "team-expertise")
                    }
                  >
                    Expertise
                  </a>
                </li>
                <li>
                  <a
                    href="#company-why-goldly"
                    onClick={(event) => handleDetail(event, "why-goldly")}
                  >
                    Why Goldly
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    onClick={(event) => handleHome(event, "contact")}
                  >
                    Contact
                  </a>
                </li>
              </>
            ) : (
              <>
                <li>
                  <a
                    href="#/cloud"
                    className="nav-cloud-link"
                    onClick={handleCloud}
                  >
                    AI Cloud Console
                  </a>
                </li>
                <li>
                  <a
                    href="#agents"
                    className="page-scroll"
                    onClick={closeMobileMenu}
                  >
                    Agents
                  </a>
                </li>
                <li>
                  <a
                    href="#features"
                    className="page-scroll"
                    onClick={closeMobileMenu}
                  >
                    Why Us
                  </a>
                </li>
                <li>
                  <a
                    href="#about"
                    className="page-scroll"
                    onClick={closeMobileMenu}
                  >
                    About
                  </a>
                </li>
                <li>
                  <a
                    href="#services"
                    className="page-scroll"
                    onClick={closeMobileMenu}
                  >
                    Business
                  </a>
                </li>
                <li>
                  <a
                    href="#portfolio"
                    className="page-scroll"
                    onClick={closeMobileMenu}
                  >
                    Products
                  </a>
                </li>
                <li>
                  <a
                    href="#testimonials"
                    className="page-scroll"
                    onClick={closeMobileMenu}
                  >
                    Cases
                  </a>
                </li>
                <li>
                  <a
                    href="#team"
                    className="page-scroll"
                    onClick={closeMobileMenu}
                  >
                    Global
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    className="page-scroll"
                    onClick={closeMobileMenu}
                  >
                    Contact
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
